module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/smartmap-80ec5fd864b65b1dc8f96c52bf64d4a0.jpeg";